import axios from '../../utils/axios';

export default function addLGBillTarget(adminId, data) {
    return (
        axios.post(`/admin/${adminId}/lGBillTarget`,  data )
    )
}
